<nz-form-item>
    <nz-form-label [nzFor]="'copyInput'">
      Your Link
      <i
        nz-icon
        nzType="copy"
        nzTheme="outline"
        style="cursor: pointer; margin-left: 8px;"
        (click)="copyToClipboard()"
      ></i>
    </nz-form-label>
    <nz-form-control>
      <input nz-input [value]="myLink" [disabled]="true" id="copyInput" />
    </nz-form-control>
  </nz-form-item>